import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, tap, combineLatest, of, switchMap } from 'rxjs';

import { filterBoolean } from '@recruitee/common';
import { DepartmentActions, DepartmentSelectors } from '@recruitee/department-data';
import { JobsCombinedSelectors } from '@recruitee/offers-data';
import {
  RequisitionsActions,
  RequisitionsFilterCountersActions,
} from '@recruitee/requisitions-data';
import {
  RequisitionsConfigActions,
  RequisitionsFlowsActions,
} from '@recruitee/requisitions-settings-data';
import { RequisitionsScope } from '@recruitee/requisitions-types';

@Injectable()
export class RequisitionsListResolver {
  constructor(private store: Store) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.store.dispatch(RequisitionsConfigActions.fetch());
    this.store.dispatch(RequisitionsFlowsActions.fetchCollection());
    this.store.dispatch(DepartmentActions.fetchCollection());
    this.store.dispatch(RequisitionsFilterCountersActions.fetch());

    return combineLatest([
      this.store.select(JobsCombinedSelectors.activeItemsAndArchivedBrief).pipe(filterBoolean),
      this.store.select(DepartmentSelectors.isLoaded()).pipe(filterBoolean),
    ]).pipe(
      tap(() =>
        this.store.dispatch(
          RequisitionsActions.fetchCollection({ payload: { scope: RequisitionsScope.Active } }),
        ),
      ),
      switchMap(() => of(true)),
    );
  }
}
